<template>
  <v-dialog
    v-if="current_levelprofile !== null"
    v-model="show_dialog"
    width="500"
    persistent
  >
    <v-card
    >
      <v-card-title>
        {{ $store.getters.get_kentix_levelprofile(current_levelprofile.levelprofile_id).name }} von {{ current_user.fullname }}
      </v-card-title>
      <v-card-subtitle>
        Regelung gilt ab Mitternacht des angezeigten Tages.
      </v-card-subtitle>
      <v-card-text>
        <v-menu
          ref="calender_unlock_at"
          v-model="menu_unlock_at"
          :close-on-content-click="false"

          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="unlock_at"
              label="Schließgruppe entsperren"
              prepend-icon="mdi-calendar"
              readonly
              dense
              v-bind="attrs"
              v-on="on"
              clearable
              outlined
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="unlock_at"
            no-title
            @input="menu_unlock_at = false"
          >
          </v-date-picker>
        </v-menu>
        <v-menu
          ref="calender_lock_at"
          v-model="menu_lock_at"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="lock_at"
              label="Schließgruppe sperren"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              dense
              v-on="on"
              clearable
              outlined
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="lock_at"
            no-title
            @input="menu_lock_at = false"
          >
          </v-date-picker>
        </v-menu>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          text
          @click="close"
        >
          Schließen
        </v-btn>
        <v-btn
          color="primary"
          text
          @click="okay"
        >
          Bestätigen
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ls-rangepicker",
  props: ['current_levelprofile', 'current_user'],
  data: () => ({
    show_dialog: true,
    lock_at: null,
    unlock_at: null,
    menu_lock_at: false,
    menu_unlock_at: false,
  }),
  watch: {
    current_levelprofile(newVal){
      if(newVal === null){
        this.lock_at = null
        this.unlock_at = null
      }
      else {
        this.lock_at = this.current_levelprofile.lock_at === null ? null : this.transformDate(new Date(this.current_levelprofile.lock_at).toLocaleDateString())
        this.unlock_at = this.current_levelprofile.unlock_at === null ? null : this.transformDate(new Date(this.current_levelprofile.unlock_at).toLocaleDateString())
      }
    }
  },
  methods: {
    transformDate (date) {
      if (!date) return null
      const [day, month, year] = date.split('.')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    close(){
      this.$parent.current_levelprofile = null
    },
    okay(){
      let new_lock_at = this.lock_at
      let new_unlock_at = this.unlock_at
      let query = '?'
      query = new_lock_at != null ?  query + 'lock_at=' + new_lock_at : query
      query = new_unlock_at != null ? query + '&unlock_at=' + new_unlock_at : query
      this.$store.dispatch("update", { "payload_type": 'PUT', "context": "/kentix/user/" + this.current_user.kentix_id + "/levelprofile/" + this.current_levelprofile.levelprofile_id + query})
      this.$parent.current_levelprofile = null
    }
  },
};
</script>

<style scoped>

</style>
